import { render, staticRenderFns } from "./Travels.vue?vue&type=template&id=22b0cd4e&scoped=true"
import script from "./Travels.vue?vue&type=script&lang=js"
export * from "./Travels.vue?vue&type=script&lang=js"
import style0 from "./Travels.vue?vue&type=style&index=0&id=22b0cd4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b0cd4e",
  null
  
)

export default component.exports